import { Component } from '@angular/core';
import { AuthService, Language, UtilityLanguageSuffix } from 'shared-lib';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent {
  title = 'CAIMS.NgV3';

  constructor(
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
     var color = localStorage.getItem('colorCode');
     if (color != null) {
       this.setUtilityColors(color);
       }else {
       this.setBpsAdminColors();
     }
    this.setLanguage();
  }

  setUtilityColors(color:string){
    document.documentElement.style.setProperty('--primary-color', color);
    document.documentElement.style.setProperty('--bg-color', color+'08');
    document.documentElement.style.setProperty('--table-root-bg-color', color+'15');
    document.documentElement.style.setProperty('--card-color', color+'22');
    document.documentElement.style.setProperty('--bubble-color', color+'95');
  }
  setBpsAdminColors(){
    document.documentElement.style.setProperty('--primary-color', '#03423E');
    document.documentElement.style.setProperty('--bg-color', '#F5FBFA');
    document.documentElement.style.setProperty('--table-root-bg-color', '#EBF1F1');
    document.documentElement.style.setProperty('--card-color', '#e4ecea');
    document.documentElement.style.setProperty('--bubble-color', '#688F8D');
  }

  setLanguage() {
    const langIndex = parseInt(localStorage.getItem('preferredLanguage') ?? '0', 10);
    const suffixes: UtilityLanguageSuffix[] = JSON.parse(localStorage.getItem('languageSuffixes') ?? '[]');
    const fileName = langIndex === Language.English ? 'en' : 'fr';
    const suffix = suffixes.find(x => x.language === langIndex)?.suffix || '';
    const translationFileName = `${fileName}${suffix}`;

    this.translate.setDefaultLang('en');
    this.translate.use(translationFileName);
  }
}
